export default __webpack_public_path__ + "static/media/sunset.6ff7d298.jpeg";